import client from "./client";

export interface PubNubConfig {
  pubKey: string;
  subKey: string;
}

export async function getPubNubConfig(): Promise<PubNubConfig> {
  const res = await client.get<{ result: PubNubConfig }>(
    "/api/chat-settings/pubnub-config",
  );
  return res.data.result;
}
